export enum Layout {
  Mobile = 1,
  Desktop = 2,
}

export const DESKTOP_MEDIA_QUERY = '(min-width: 1200px)';
